/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Welcome_S1_DropInputs */

const en_funnel_ob_welcome_s1_drop = /** @type {(inputs: Funnel_Ob_Welcome_S1_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop a file or paste a link`)
};

const es_funnel_ob_welcome_s1_drop = /** @type {(inputs: Funnel_Ob_Welcome_S1_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suelta un archivo o pega un enlace`)
};

/**
* | output |
* | --- |
* | "Drop a file or paste a link" |
*
* @param {Funnel_Ob_Welcome_S1_DropInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_welcome_s1_drop = /** @type {((inputs?: Funnel_Ob_Welcome_S1_DropInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Welcome_S1_DropInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_welcome_s1_drop(inputs)
	return en_funnel_ob_welcome_s1_drop(inputs)
});